'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * A user or entity avatar - can have an image or just child content
 *
 * @param img image url
 */
var Avatar = function Avatar(_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === undefined ? 'div' : _ref$as,
      img = _ref.img,
      _ref$variant = _ref.variant,
      variant = _ref$variant === undefined ? 'secondary' : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 'normal' : _ref$size,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      props = _objectWithoutProperties(_ref, ['as', 'img', 'variant', 'size', 'className']);

  var As = as;
  return React.createElement(As, _extends({}, props, {
    className: 'Avatar variant-' + variant + ' size-' + size + ' ' + className,
    style: { backgroundImage: img ? 'url(\'' + img + '\')' : '' }
  }));
};

exports.default = Avatar;